import React from 'react';

/**
 * NoteCORE inline SVG logo — sky-blue → indigo → violet gradient.
 * Works in both light and dark modes.
 * height: string or number (default '28px')
 */
const LogoSVG = ({ height = '28px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 228 38"
      fill="none"
      style={{ height, width: 'auto', display: 'block' }}
      aria-label="NoteCORE"
    >
      <defs>
        {/* Icon mark gradient: sky → violet */}
        <linearGradient id="ncIconGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor="#38bdf8" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>

        {/* Wordmark gradient across the full text span */}
        <linearGradient id="ncTextGrad" gradientUnits="userSpaceOnUse"
          x1="42" y1="0" x2="228" y2="0">
          <stop offset="0%"   stopColor="#38bdf8" />
          <stop offset="45%"  stopColor="#6366f1" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
      </defs>

      {/* ── Icon mark: rounded square + note lines (vertically centred in 38px) ── */}
      <rect x="0" y="3" width="32" height="32" rx="8" fill="url(#ncIconGrad)" />
      <path d="M22 11 L24 11 Q26 11 26 13 L26 15 Z" fill="rgba(255,255,255,0.35)" />
      <rect x="8"  y="16"   width="16" height="2.2" rx="1.1" fill="white" />
      <rect x="8"  y="21.2" width="13" height="2.2" rx="1.1" fill="white" opacity="0.75" />
      <rect x="8"  y="26.4" width="9"  height="2.2" rx="1.1" fill="white" opacity="0.5" />

      {/* ── Wordmark ── */}
      <text
        x="42"
        y="32"
        fontFamily="'DM Sans', 'Inter', Arial, sans-serif"
        fontSize="32"
        letterSpacing="-0.5"
        fill="url(#ncTextGrad)"
      >
        <tspan fontWeight="600">Note</tspan><tspan fontWeight="800">CORE</tspan>
      </text>
    </svg>
  );
};

export default LogoSVG;
